import classNames from 'classnames';
import React from 'react';
import * as styles from './NotificationCountBadge.module.scss';

interface NotificationCountBadgeProps {
  count: number;
}

const NotificationCountBadge = (props: NotificationCountBadgeProps) => {
  const count = Math.min(props.count, 99);

  if (count === 0) {
    return null;
  }

  return (
    <div
      className={classNames(styles.badge, {
        [styles.one]: count === 1,
        [styles.singleDigit]: count < 10 && count > 1,
        [styles.doubleDigit]: count >= 10,
      })}
    >
      {count}
    </div>
  );
};

export default NotificationCountBadge;
